(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory;
  else {
    if (root.location.pathname !== '/pages/contact' || root.RealleaderEnquiryTracking) return;
    var privacyReady = false;
    var attemptedHere = false;
    function consent() {
      if (!privacyReady) return 'unknown';
      try {
        var privacy = root.Shopify && root.Shopify.customerPrivacy;
        if (!privacy) return 'unknown';
        var methods = ['analyticsProcessingAllowed', 'marketingAllowed', 'saleOfDataAllowed'];
        var states = methods.map(function (name) {
          return typeof privacy[name] === 'function' ? privacy[name]() : undefined;
        });
        if (states.some(function (value) { return value === false; })) return 'denied';
        return states.every(function (value) { return value === true; }) ? 'granted' : 'unknown';
      } catch (_) { return 'unknown'; }
    }
    var storage;
    try { storage = root.sessionStorage; } catch (_) { storage = null; }
    var controller = factory({
      consent: consent,
      storage: storage,
      now: Date.now,
      id: function () {
        if (!root.crypto || typeof root.crypto.randomUUID !== 'function') return null;
        return root.crypto.randomUUID();
      },
      publish: function (name, payload) {
        var api = root.Shopify && root.Shopify.analytics;
        if (!api || typeof api.publish !== 'function') return false;
        return api.publish(name, payload);
      }
    });
    root.RealleaderEnquiryTracking = controller;
    function checkResult() {
      if (attemptedHere) {
        if (consent() === 'denied') controller.accept(false);
        return;
      }
      controller.accept(!!root.document.querySelector('[data-rl-contact-server-accepted]'));
    }
    root.document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!event.isTrusted || !form || !form.matches('#ContactEnquiry.native-enquiry')) return;
      attemptedHere = !!controller.attempt(!event.defaultPrevented && form.checkValidity());
    });
    root.document.addEventListener('visitorConsentCollected', checkResult);
    root.addEventListener('pageshow', checkResult);
    try {
      if (root.Shopify && typeof root.Shopify.loadFeatures === 'function') {
        root.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
          if (error) return;
          privacyReady = true;
          checkResult();
        });
      }
    } catch (_) {}
    checkResult();
  }
})(typeof window === 'object' ? window : null, function (env) {
  'use strict';
  var KEY = 'rl_contact_attempt_v2';
  var TTL = 30 * 60 * 1000;
  var busy = false;
  var submittedHere = null;
  function state() { try { return env.consent(); } catch (_) { return 'unknown'; } }
  function remove() { try { env.storage.removeItem(KEY); } catch (_) {} }
  function read() {
    try {
      var record = JSON.parse(env.storage.getItem(KEY) || 'null');
      if (!record || !/^[a-f0-9-]{36}$/i.test(record.id) ||
          !Number.isFinite(record.created) || env.now() - record.created > TTL ||
          env.now() < record.created || record.path !== '/pages/contact' ||
          !['pending', 'dispatching', 'published'].includes(record.status)) return null;
      return record;
    } catch (_) { return null; }
  }
  function write(record) {
    try { env.storage.setItem(KEY, JSON.stringify(record)); return true; }
    catch (_) { return false; }
  }
  function attempt(valid) {
    if (!valid) { if (state() === 'granted') remove(); return false; }
    if (state() !== 'granted') { remove(); return false; }
    var existing = read();
    // Repeated submit events before a response share the same attempt.
    if (existing && existing.status === 'pending') return existing.id;
    var id;
    try { id = env.id(); } catch (_) { return false; }
    if (!id || !/^[a-f0-9-]{36}$/i.test(id)) return false;
    if (!write({ id: id, created: env.now(), path: '/pages/contact', status: 'pending' })) return false;
    submittedHere = id;
    return id;
  }
  function accept(serverAccepted) {
    var consent = state();
    if (consent === 'denied') { remove(); return false; }
    if (consent !== 'granted' || busy) return false;
    if (!serverAccepted) { remove(); return false; }
    var record = read();
    // A success marker on the previous response cannot accept a new attempt
    // begun on that same page. Acceptance requires a subsequent navigation.
    if (!record || record.status !== 'pending' || record.id === submittedHere) return false;
    // Write ahead: unknown dispatch outcomes never replay on refresh.
    record.status = 'dispatching';
    if (!write(record)) return false;
    busy = true;
    try {
      var result = env.publish('realleader:lead_submitted', {
        event_id: record.id, brand: 'Realleader', enquiry_type: 'contact_form',
        page_path: '/pages/contact', submission_state: 'accepted'
      });
      if (result === false) { record.status = 'pending'; write(record); return false; }
      // A local queue acknowledgement is not proof of Meta receipt.
      record.status = 'published';
      write(record);
      return true;
    } catch (_) {
      // Keep dispatching for uncertain outcomes; do not invent receipt or retry.
      return false;
    } finally { busy = false; }
  }
  return { attempt: attempt, accept: accept };
});
